import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

type AspectRatioBoxProps = {
  children: ReactNode;
  ratioAsPercent: string;
  testId?: string;
  maxHeight?: BoxProps['maxHeight'];
};

const AspectRatioBox = ({
  children,
  ratioAsPercent,
  maxHeight,
  testId,
}: AspectRatioBoxProps) => (
  <Box
    height="0"
    overflow="hidden"
    paddingTop={ratioAsPercent}
    position="relative"
    testId={testId}
  >
    <Box
      height="100%"
      left="0"
      maxHeight={maxHeight}
      position="absolute"
      top="0"
      width="100%"
    >
      {children}
    </Box>
  </Box>
);

export { AspectRatioBox };
